import { useEffect } from "react";
import { useGetMe } from "@workspace/api-client-react";

const REFERRAL_KEY = "mooya_ref";

// Runs once per authenticated session. If the user signed up via a master
// dealer referral link (/join?ref=<dealerCode>), the code was stored in
// localStorage before the Clerk redirect. We call POST /me/referral to link
// the new agent account to that master dealer, then clear the stored code so
// subsequent logins don't re-apply it.
export function useApplyReferral() {
  const { data: me } = useGetMe();

  useEffect(() => {
    const code = localStorage.getItem(REFERRAL_KEY);
    if (!code || !me?.agentId) return;
    // Clear immediately so a network failure doesn't loop on every render.
    localStorage.removeItem(REFERRAL_KEY);
    fetch("/api/me/referral", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ code }),
    }).catch(() => {
      // Best-effort — the agent will be manually linked by an admin if needed.
    });
  }, [me?.agentId]);
}
